export default __webpack_public_path__ + "b1b58f74c4ee2e327fec4aefcb3d83c3.jpg";